<template>
  <div class="content">
    <s-location use title="증표 사용 내역 조회·수정"/>
		<!-- <h4 class="sub_title02">증표 내역 입력/수정</h4> -->

    <!-- <h4 class="sub_title02">증표 내역 입력/수정</h4> -->

    <!--  주의사항  -->
    <div class="comment_bar expcomment mt20">
      <template v-if="$store.state.session.user.type != 'master'">
        <li>본 메뉴는 회원 본인이 직접 사용한 증표 내역만 조회할 수 있습니다.</li>
        <li>법무법인, 법무법인(유한), 공동 법률사무소에서 담당 변호인 또는 공동변호인으로 지정된 경우에는 <em @click="$router.push('/report/report_viadetail')" class="blue01">(수임사건 내역 조회 > 수임사건 상세 조회)</em>에서 확인 가능합니다.</li>
      </template>
      <li v-else>마스터 아이디는 모든 소속 변호사의 증표 사용내역을 조회할 수 있습니다.</li>



    </div>


    <div class="btn_group wide mt0">
      <div class="right">
        <button @click="initData" class="btn icon reload">초기화</button>
        <button @click="doSearch()" class="btn icon search_black">검색</button>
        <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button>
      </div>
    </div>
    <table class="tbl01 sch_tbl wide">
      <tr>
        <th>증표 종류</th>
        <td  class="radio_inline">
          <c증표종류_검색폼 :search.sync="search" />
        </td>
      </tr>
      <tr>
        <th>증표 번호</th>
        <td>
          <!-- <input type="text" v-model="search.iv_rcptnofr" class="w_inputno" @keyup.enter="doSearch()" v-mask="'#####'" v-on:keyup="$event.target.value.length >= 5 && $event.target.nextElementSibling.focus()"/> -
          <input type="text" v-model="search.iv_rcptnoto" class="w_inputno" @keyup.enter="doSearch()" v-mask="'######'"/> -->
          <input type="text" v-model="search.iv_rcptno1" class="w_inputno" @keyup.enter="doSearch()" v-mask="'#####'" v-on:keyup="$event.target.value.length >= 5 && $event.target.nextElementSibling.focus()"/> -
          <input type="text" v-model="search.iv_rcptno2" class="w_inputno" @keyup.enter="doSearch()" v-mask="'######'"/>
        </td>
      </tr>
      <tr>
        <th>검색어</th>
        <td>
<!--           <select v-model="search.iv_ktype">
            <option value="ALL"      >전체</option>
            <option value="MEMBNM"   >증표명의</option>
            <option value="CLIENT"   >위임인</option>
            <option value="OTHERSIDE">상대방</option>
            <option value="REMK"     >비고</option>
          </select> -->
          <!-- 검색 항목 : 증표명의, 위임인, 상대방, 관할기관, 사건명, 사건번호, 비고  -->
          <input type="text" class="sch_input" title="검색어" v-model="search.iv_kword" placeholder="검색 (증표명의, 관할기관, 사건명, 위임인, 상대방, 사건번호, 비고)" @keyup.enter="doSearch()"/>
          &nbsp;
          <label>
            <input type="checkbox"
              v-model="search.iv_linkyn"
              true-value="Y"
              false-value=""/>
            연결 사건 보기
          </label>
          <label>
            <input type="checkbox"
              v-model="search.iv_lostyn"
              true-value="Y"
              false-value=""/>
            종이증표 분실처리 보기
          </label>
        </td>
      </tr>
<!--
      <tr>
        <th>위임인</th>
        <td>
            <input type="text" v-model="search.iv_client" class="sch_input" placeholder="위임인" />
        </td>
      </tr>
      <tr>
        <th>상대방</th>
        <td>
            <input type="text" v-model="search.iv_otherside" class="sch_input" placeholder="상대방" />
        </td>
      </tr>
-->
<!--
      <tr>
        <th>연결 사건</th>
        <td>
          <input type="checkbox"
            v-model="search.iv_linkyn"
            true-value="Y"
            false-value="N"/>
          <label for="linkyn">연결 사건 보기</label>

          <span v-for="code in code.B40000" :key="code.value">
          <input
            type="radio"
            v-model="search.iv_cancelclsf"
            :value="code.value"
            class="sch_input"
          />
          <label>{{ code.text }}</label>
          </span>
        </td>
      </tr>
-->
      <tr>
         <th>날짜검색</th>
         <td>
            <select v-model="search.iv_searchdtgbn">
              <option value="V">경유일</option>
              <option value="C">수임일</option>
              <option value="S">구입일</option>
            </select>
           <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_searchfr" :placeholder="search.iv_searchfr"/><em>~</em>
           <i-input-date input-class="w_inputno mr5" title="종료일" v-model="search.iv_searchto" :placeholder="search.iv_searchto"/>
           <br class="mobile"/>
           <s-date-range :fr.sync="search.iv_searchfr" :to.sync="search.iv_searchto" />
         </td>
      </tr>
      <tr>
        <th>사임/취하 구분</th><!-- CANCELCLSF -->
        <td>
          <label><input class="ml10" type="radio" v-model="search.iv_cancelclsf" value=""       />전체</label>
          <label><input class="ml10" type="radio" v-model="search.iv_cancelclsf" value="B40200" />사임</label>
          <label><input class="ml10" type="radio" v-model="search.iv_cancelclsf" value="B40200A"/>전체사임</label>
          <label><input class="ml10" type="radio" v-model="search.iv_cancelclsf" value="B40200P"/>일부사임</label>
          <label><input class="ml10" type="radio" v-model="search.iv_cancelclsf" value="B40300" />취하</label>
        </td>
      </tr>
      <tr>
        <th>증표 구분</th>
        <td>
          <label><input class="ml10" type="radio" v-model="search.iv_onlineyn" value=""  />전체</label>
          <label><input class="ml10" type="radio" v-model="search.iv_onlineyn" value="Y" /><img src="/images/common/icon_online2.png"  class="icon_online" title="전자증표"> 전자증표</label>
          <label><input class="ml10" type="radio" v-model="search.iv_onlineyn" value="N" />종이증표</label>
<!--           <select v-model="search.iv_onlineyn"  style="width:80px">
            <option value="">전체</option>
            <option value="Y">온라인</option>
            <option value="N">오프라인</option>
          </select> -->
        </td>
      </tr>
    </table>

    <s-excel
      ref="excel"
      excel-api="/proc_excel/N_VIAINFO_SEL_LIST_EMP"
      excel-filename = "증표_사용_내역"
      :excel-top ="``"
      excel-headers = "
          text                         | value        | format          | align
          구입일자                     | selldt       | YYYY.MM.DD.
          증표명의                     | ownernm      |
          증표종류                     | caseclsfnm   |
          증표번호                     | rcptno       | insertHyphen(5)
          금액                         | viafee       | comma           | right
          경유일자                     | viadt        | YYYY.MM.DD.
          관할기관                     | isttoutplac  |
          사건명                       | casenm       |
          위임인 구분                  | clientclsf   |
          위임인                       | client       |
          상대방                       | otherside    |
          온라인여부                   | onlineyn     |
          수임일자                     | cntchargdt   | YYYY.MM.DD.
          사건유형                     | casetypenm   |
          심급                         | simgeupnm    |
          심급(기타)                   | simgeup_etc  |
          사건번호                     | caseno       |
          담당변호사                   | membnms      |
          타회소속 분사무소 담당변호사 | submembers   |
          연결사건 처리                | linkyn       |
          수임액                       | pay_con      | comma          | right
          성공보수금                   | pay_succ     | comma          | right
          비고                         | remk         |
      "
      :excel-param = "()=>({
        ...search,
        ...this.search_fix,
        iv_pgsize       : '-1',
        iv_page         : '1',
    })"/>
    <!-- 테이블 -->
    <div class="scroll_wrap"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <s-loading v-if="list.loading" />
      <table class="tbl01 thin  wide">
        <thead>
          <tr>
            <th class="no">순번</th>
            <th class="date">구입일자</th>
            <th class="vianame">증표명의</th>
            <th class="viakind">증표<br class="mobile"/>종류</th>
            <th class="viano">증표번호</th>
            <th class="">경유일자</th>
            <th class="viakind">사건<br class="mobile"/>유형</th>
            <th class="" >관할기관</th>
            <th>사건명</th>
            <th>위임인 구분</th>
            <th>위임인</th>
            <th>상대방</th>
            <th class="date">수임일자</th>
            <th>사건번호</th>
            <th>비고</th>
            <th width="60px">수정</th>
          </tr>
        </thead>
            <!-- <th class="yn3">온라인</th> -->
            <!-- <th class="td_org01 ">담당변호사</th> -->

        <tr v-for="(item,i) in list.items" :key=i>
          <td>{{ list.totalCount - ((search.pageNo -1) * search.listSize) - i }}</td>
          <td>{{ item.selldt | moment('YY.MM.DD.') }}</td>
          <td v-html="T.nl_to_br(item.ownernm)"></td>
          <td :class="{ 'td_gray01' : true, 'blue01 b' : item.ch_caseyn == 'Y' }" :id="`id_chcase_${item.ch_caseyn}`">
            <span v-html="T.f_org_br(item.org_caseclsfnm)"/>
            <div class="toggleInfo">
                <p class="tit">오사용 증표 정정 신청한 증표임 </p>
                <div class="cont">
                  <ol>
                    <li>신청일 : {{ item.viastatdt | moment('YYYY.MM.DD.') }}</li>
                    <li>변경 전 경유 증표 : {{ item.org_caseclsf }}, {{ item.org_viafee | comma }}원</li>
                    <li>변경 후 경유 증표 : {{ item.to_caseclsf }},  {{ item.to_viafee  | comma }}원</li>
                    <li>정정사유 : {{ item.rchcase_reasonclsfnm }}</li>
                  </ol>
                </div>
              </div>
          </td>
          <td class=" pr_online">{{ item.rcptno | rcptno }}<img v-if="item.onlineyn == 'Y'" src="/images/common/icon_online2.png" title="온라인증표" class="icon_online"></td>
          <td>{{ item.viadt | moment('YY.MM.DD.') }}</td>
          <td>{{ item.casetypenm }}</td>
          <td>{{ item.isttoutplac }}</td>
          <td>{{ item.casenm }}</td>
          <td>{{ item.clientclsf }}</td>
          <td>{{ item.client }}</td>
          <td>{{ item.otherside }}</td>
          <td>{{ item.cntchargdt | moment('YY.MM.DD.') }}</td>
          <td>{{ item.caseno }}</td>
          <td>{{ item.remk }} </td>
          <td>
            <template v-if="item.lostyn == 'Y'">분실</template>
            <button v-else class="btn xxs org01 outline" @click="callDialogViaUse(item)">수정/인쇄</button>
          </td>
        </tr>

          <!-- <td>{{ item.onlineyn }}</td> -->
          <!-- <td>{{ item.membnms }}</td> -->


      </table>
    </div><!--scroll_wrap -->
    <!-- //변경내용 -->

    <div class="paging wide">
      <p class="num">
        <s-page :pageNo.sync="search.pageNo" :totalCount="list.totalCount" :listSize="search.listSize" @changePage="pageNo=>doSearch(pageNo)"/>
      </p>
    </div>

	</div> <!-- content : width=950px; -->
</template>

<script>
let ui
import ModalViaFormVue from '../../components/ModalViaForm.vue';
export default {
  components: {
    'c증표종류_검색폼'   : require('@/components/c증표종류_검색폼.vue').default
  },
  data () {
    return {
      search : {},
      search_fix : {
        iv_menu         : 'edit',
        iv_statclsf     : "BC0200",     // 사용건만 출력
      },
      search_init : {
        listSize        : 10,
        pageNo          : 1,
        iv_selldtfr     : "",
        iv_selldtto     : "",
        iv_viadtfr      : "",
        iv_viadtto      : "",
        iv_viaplac      : "",
        iv_caseclsf     : "",
        iv_rcptno1      : "",
        iv_rcptno2      : "",
        iv_rcptnofr     : "",
        iv_rcptnoto     : "",
        iv_cntchargdtfr : "",
        iv_cntchargdtto : "",
        iv_client       : "",
        iv_isttoutplac  : "",
        iv_otherside    : "",
        iv_linkyn       : "",
        iv_lostyn       : "",
        iv_onlineyn     : "",
        iv_lawyernm     : "",
        iv_membclsf     : "",
        iv_membno       : "",
        iv_membnm       : "",
        iv_viamembclsf  : "",
        iv_viamembno    : "",
        iv_officeclsf   : "",
        iv_officeno     : "",
        iv_order_by1    : "",
        iv_order_by2    : "",
        iv_order_by3    : "",
        iv_order_by4    : "",
        iv_freeclsf     : "",
        iv_case_b10300  : "",
        iv_ktype        : "ALL",
        iv_kword        : "",
        iv_cancelclsf   : "",
        iv_searchdtgbn  : "V", // 검색날짜 : 경유일
        iv_searchfr     : "",//this.$moment().subtract(10, 'year').format("YYYY-MM-DD"), // 1 년 전
        iv_searchto     : this.$moment().format("YYYY-MM-DD"),
      },
      sitem : {
        reasonclsf : ''
      , reasonremk : ''
      },
      code: {},
      chkAll : false,
      list: {
        loading: false,
        items: [],
        totalCount: 0,
      },
      saveList : [],
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },
      org_perm: {},
    }
  },
  watch : {
    '$route': 'getData',
  },
  created() {
    ui = this.$ui;
    this.search = _.cloneDeep(this.search_init)
    if (this.$store.state.session.user.type != 'self') {  // 개인변호사가 아니면 다 있다
      ui.httpGet("/proc/N_OFFICE_MEM_SEL_DTL", {}, ret => this.org_perm = ret.data.rs1[0])
    }
    ui.codeLoad("B40000", code => {
      this.code = code
    });
    this.getData();
  },
  mounted() {
    // 공통 코드 로드
    // this.doSearch()
  },
  methods : {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = _.cloneDeep(this.search_init)
      this.doSearch()
    },
    callVieModal(item) {
      // this.$refs.dialog_usevia.open(item) // 원래소스

    // :name="modalName"
    // adaptive reset
    // draggable=".window-header"
    // @closed="closed"
    // overlayTransition=""
    // width="900"
    // height="auto" scrollable
    // :clickToClose=false

      this.$modal.show(ModalViaFormVue, {
        // 프로퍼티
        menu: 'front_edit',
        param: item,
          // 없음
        // 콜백
        cb_save: this.getData,
        // cb_via_use_ok: this.via_use_ok,
      }, {
        // 모달 속성
//        class: 'v--modal-overlay test-modal',
        name: "viaForm_" + T.randomAZ(10), // 모달 이름 (unique)
        adaptive: true,
        // reset: true,
        // draggable: ".window-header",
        // overlayTransition: "",
        width: "900",
        height: (Math.min(1000, this.windowHeight -25) ),
        // height: this.windowHeight - 25,
        // height: 'auto',
        // scrollable: true, // height: auto 하고 scrollable:true 는 한세트
      // scrollable: true를 하게되면 IE9 에서 작동하지 않는다. 절대 주지 말자.
      // 또는 $device.fullBrowserVersion == 9 && $device.isIE == true 일때 false 로 하고 그 외에는 true로 하자

        clickToClose: false,

        // resizable: true,
        // pivotY: 0.3,
      }, {
        // 이벤트
        // 'before-close': (e,v) => { console.log('모달을 닫는다1. event =', e); console.log('모달을 닫는다2. event =', v);  },
        // 'closed': (e,v) => { console.log('모달3 CLOSED =', e); console.log('모달4 CLOSED =', v); },

        //@closed="closed"
      })


    },
    doSearch(pageNo = 1) {
      this.search.pageNo = pageNo
      this.search._r = Math.random()
      this.$router.push({ query: T.compactObj(this.search) }) // 라우터를 변경하여 watch -> getData() 가 되게한다.
    },
    compactObj2(obj) {
      return _.omitBy(obj, v=>v === undefined || v == "" || v == 0)
    },
    getData() {
      console.log("this.$route.query = ", this.$route.query)
      T.setAttrs(this.search, this.$route.query, this.search_init)
      this.search.iv_rcptnofr = this.search.iv_rcptno1 + "" + this.search.iv_rcptno2
      this.search.iv_rcptnoto = this.search.iv_rcptnofr


      ui.httpGetList(this.list
        , '/proc/N_VIAINFO_SEL_LIST_EMP'
        , {
          ...this.search,
          ...this.search_fix,
          iv_pgsize      : this.search.listSize,
          iv_page        : this.search.pageNo,
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })
    },
    callDialogViaUse(item) { // 증표수정 버튼 클릭
      item.ch_statclsf = 'BC0200'
      item.modal_title = '증표 내역 수정'
      // this.$refs.dialog_usevia.open(item)
      this.callVieModal(item)
    },
  }
}
</script>
<style scoped>
  .h15 { display: none;}
  .tbl01 tr:nth-child(2n-1) td { border-top:1px solid #222;}
  .btn_group.wide { margin-top:80px;}

  @media screen and (max-width:640px){
    /* .btn_group.wide { margin-top:0;} */
    .scroll_wrap .tbl01 { width:1200px !important;}
    .tbl01 td .btn { padding: 6px 0px; min-width: 30px;}
    .tbl01 th.viakind { width:25px;}
    .tbl01 th.vianame { width:70px;}

  }

#id_chcase_Y .toggleInfo { margin-top:0px; margin-left:30px; width:320px; height:200px;}
#id_chcase_Y:hover .toggleInfo { display: inline-block }
</style>

